import AsyncLock from 'async-lock';

export const liveQuerySubscribeLock = new AsyncLock({ timeout: 10000 });
export const LIVE_QUERY_SUBSCRIBE_LOCK_KEY = 'liveQuerySubscribeLockKey';
